import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

export interface ObjectWorkspaceTab {
  objectId: string;
  name: string;
}

/**
 * Presentational browser-style tab bar for the open objects in the workspace shell. Renders a tab
 * per open object with click and close affordances; the shell owns all routing and state.
 */
@Component({
  selector: 'crm-object-workspace-tab-bar',
  templateUrl: './object-workspace-tab-bar.component.html',
  styleUrls: ['./object-workspace-tab-bar.component.scss'],
  imports: [MatTabsModule, MatIconModule, MatTooltipModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ObjectWorkspaceTabBarComponent {
  readonly tabs = input<ObjectWorkspaceTab[]>([]);
  readonly activeObjectId = input<string | null>(null);

  readonly tabClick = output<string>();
  readonly tabClose = output<string>();
}
